import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=6a313038"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a313038')) {
      api.createRecord('6a313038', component.options)
    } else {
      api.reload('6a313038', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=6a313038", function () {
      api.rerender('6a313038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/layout.vue"
export default component.exports